import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const transactionCancel = http.patch(
  createMockEndpoint('/transaction/:id/cancel'),
  async () => {
    await delay(500);
    return HttpResponse.json({}, { status: 200 });
  },
);
